// CutestCoops lead form wiring (global)
// Loads on every page via theme.liquid <script src="{{ 'lead-form.js' | asset_url }}" defer>
(function () {
  if (window.__cc_loaded) return; window.__cc_loaded = true;

  const dl = (window.dataLayer = window.dataLayer || []);
  const qs = new URLSearchParams(location.search);

  // Persist UTMs/gclid
  const trackKeys = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid'];
  trackKeys.forEach(k => { const v = qs.get(k); if (v) { try { localStorage.setItem(k, v); } catch(_){} }});
  const getStored = k => { try { return qs.get(k) || localStorage.getItem(k) || ''; } catch(_) { return qs.get(k) || ''; } };

  // IDs
  const uuid = () =>
    ([1e7]+-1e3+-4e3+-8e3+-1e11).toString().replace(/[018]/g,c=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c/4).toString(16));
  const ensureId = (key, pref) => {
    try { let v = localStorage.getItem(key); if (!v) { v = pref + '-' + uuid(); localStorage.setItem(key, v); } return v; }
    catch(_) { return pref + '-' + uuid(); }
  };
  const sess  = ensureId('cc_session_id', 'sess');
  const visit = ensureId('cc_visitor_id', 'vis');

  // Wire any matching form(s)
  function wire(form) {
    if (!form || form.__cc_wired) return;
    form.__cc_wired = true;

    // Populate hidden fields if present
    const byId = id => document.getElementById(id);
    const setVal = (el, val) => { if (el) el.value = val; };

    setVal(byId('cc_session_id'),  sess);
    setVal(byId('cc_visitor_id'),  visit);
    setVal(byId('cc_utm_source'),  getStored('utm_source'));
    setVal(byId('cc_utm_medium'),  getStored('utm_medium'));
    setVal(byId('cc_utm_campaign'),getStored('utm_campaign'));
    setVal(byId('cc_utm_term'),    getStored('utm_term'));
    setVal(byId('cc_utm_content'), getStored('utm_content'));
    setVal(byId('cc_gclid'),       getStored('gclid'));

    // View event
    dl.push({event:'form_view', form_name:'cutestcoops_lead', form_id: form.id || 'ccLeadForm', page_location:location.href, page_title:document.title});

    // Start event
    let started = false;
    form.addEventListener('input', () => {
      if (started) return; started = true;
      dl.push({event:'form_start', form_name:'cutestcoops_lead', form_id: form.id || 'ccLeadForm', page_location:location.href});
    }, { once:true });

    // Always prevent default nav (capture so it wins)
    const prevent = e => { if (e && e.preventDefault) e.preventDefault(); return false; };
    form.addEventListener('submit', prevent, true);

    const validEmail = e => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e || '');
    const digits     = p => (p || '').replace(/\D/g,'');

    form.addEventListener('submit', async (e) => {
      prevent(e);

      const q = s => form.querySelector(s);
      const name        = (q('#cc_name')        || {}).value?.trim() || '';
      const email       = (q('#cc_email')       || {}).value?.trim() || '';
      const phone       = digits((q('#cc_phone')|| {}).value);
      const coop_status = (q('#cc_coop_status') || {}).value || '';
      const flock_raw   = (q('#cc_flock_size')  || {}).value || '';
      const flock_size  = flock_raw ? parseInt(flock_raw, 10) : null;

      const msg = q('#cc_msg') || (() => { const p = document.createElement('p'); p.id='cc_msg'; p.className='cc-msg'; form.appendChild(p); return p; })();
      const btn = q('.cc-btn');

      const showMsg = (text, ok) => { msg.textContent = text; msg.className = 'cc-msg ' + (ok ? 'success' : 'error'); msg.style.display = 'block'; };

      if (!name || !validEmail(email) || !phone) {
        showMsg('Please complete Name, a valid Email, and Phone.', false);
        return;
      }

      dl.push({event:'form_submit', form_name:'cutestcoops_lead', form_id: form.id || 'ccLeadForm', page_location:location.href});

      const payload = {
        landing_page_slug: 'cutest-coops',
        form_data: {
          name, email, phone,
          coop_status: coop_status || undefined,
          flock_size: (typeof flock_size === 'number' && !isNaN(flock_size)) ? flock_size : undefined,
          _spam_analysis: {
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            deviceHash: (() => { try { return localStorage.getItem('cc_device_hash') || (localStorage.setItem('cc_device_hash', uuid()), localStorage.getItem('cc_device_hash')); } catch(_) { return uuid(); } })()
          }
        },
        utm_source:  getStored('utm_source')  || undefined,
        utm_medium:  getStored('utm_medium')  || undefined,
        utm_campaign:getStored('utm_campaign')|| undefined,
        utm_term:    getStored('utm_term')    || undefined,
        utm_content: getStored('utm_content') || undefined,
        gclid:       getStored('gclid')       || undefined,
        session_id:  sess,
        visitor_id:  visit
      };

      try {
        btn && btn.setAttribute('disabled','disabled');
        const res = await fetch('https://analytics.gomega.ai/submission/submit', {
          method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload), credentials:'omit', mode:'cors'
        });
        if (!res.ok) throw new Error('HTTP '+res.status+' '+(await res.text()).slice(0,200));
        showMsg('Thanks! We’ll be in touch shortly.', true);
        form.reset();
        dl.push({event:'form_success', form_name:'cutestcoops_lead', form_id: form.id || 'ccLeadForm', lead_type:'Contact', page_location:location.href});
        // Optional redirect: location.href = '/pages/thank-you';
      } catch (err) {
        showMsg('Something went wrong. Please try again or email us.', false);
        dl.push({event:'form_error', form_name:'cutestcoops_lead', form_id: form.id || 'ccLeadForm', error_message: String(err && err.message || 'unknown'), page_location:location.href});
      } finally {
        btn && btn.removeAttribute('disabled');
      }
    }, false);
  }

  // Run when DOM is ready
  const run = () => {
    // Support #ccLeadForm or data-cc-lead
    const forms = new Set([
      ...document.querySelectorAll('#ccLeadForm'),
      ...document.querySelectorAll('form[data-cc-lead]')
    ]);
    forms.forEach(wire);
  };

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Auto-wire forms injected later (e.g., editor blocks)
  const mo = new MutationObserver(() => {
    document.querySelectorAll('#ccLeadForm, form[data-cc-lead]').forEach(wire);
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });
})();

(function () {
  function hookTriggers() {
    const modal = document.getElementById('cc-lead-modal');
    if (!modal || !('open' in modal)) return; // Dawn details-modal defines .open()

    function openModal(e) {
      e.preventDefault();
      modal.open(); // provided by details-modal.js
      // optional: focus first field after open
      setTimeout(() => {
        const first = document.getElementById('cc_name');
        if (first) first.focus();
      }, 50);
    }

    document.querySelectorAll('[data-cc-open]').forEach(a => {
      if (!a.__ccBound) { a.addEventListener('click', openModal); a.__ccBound = true; }
    });

    // Intercept any #contact link
    document.querySelectorAll('a[href="#contact"]').forEach(a => {
      if (!a.__ccBound) { a.addEventListener('click', openModal); a.__ccBound = true; }
    });
  }

  if (document.readyState !== 'loading') hookTriggers();
  else document.addEventListener('DOMContentLoaded', hookTriggers);

  // In case header/menu is re-rendered dynamically
  new MutationObserver(hookTriggers).observe(document.documentElement, { childList: true, subtree: true });
})();